<template>
    <v-container fill class="pa-0">
        <p v-if="!documentAccountingPeriod" class="text-red pt-0">
            Attention : afin d'accèder aux modules de révision comptable, il est indispensable de
            créer l'exercice comptable.
        </p>

        <v-card
            v-else
            class="default_card_wm mx-auto pt-2 px-4"
            style="
                background: #fff !important;
                border: solid rgba(0, 0, 0, 0.12) 1px;
                box-shadow: none;
            "
        >
            <!-- // ++ CUT-OFF -->
            <!-- // ** title revision + windowStep = 10 -->
            <v-row no-gutters v-if="showAdjustments">
                <v-col cols="10" class="d-flex align-center pr-2">
                    <span> Cut-off </span>

                    <span
                        class="text-red"
                        v-if="
                            documentAdjustmentAcrStatus &&
                            documentAdjustmentAcrStatus === 'TO_UPDATE'
                        "
                    >
                        &#x3164;document modifié : les régularisations sont à refaire
                    </span>
                </v-col>

                <v-spacer />

                <!-- // ++ CUT-OFF -->
                <v-col cols="1" class="d-flex align-center justify-end">
                    <template v-if="disabledAuditReportLines">
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <div v-bind="props">
                                    <v-btn-icon
                                        icon=" $oss-edit "
                                        :disabled="disabledAuditReportLines"
                                        v-bind="props"
                                        size="x-small"
                                    />
                                </div>
                            </template>

                            <span
                                v-if="
                                    tooltipDocumentAdjustmentBtn &&
                                    tooltipDocumentAdjustmentBtn.length
                                "
                                >{{ tooltipDocumentAdjustmentBtn }}</span
                            >
                        </v-tooltip>
                    </template>

                    <!-- // ++ CUT-OFF -->
                    <template v-else>
                        <!-- <p>windowStep</p> -->
                        <!-- ** if ACR -->
                        <template v-if="documentAdjustmentAcrStatus">
                            <!-- ** if status TO_UPDATE -->
                            <v-btn-warning
                                v-if="documentAdjustmentAcrStatus === 'TO_UPDATE'"
                                color="error"
                                @click="goToWindowStep10"
                                size="x-small"
                            />

                            <!-- ** if status UNKNOWN (OK) -->
                            <v-btn-icon
                                v-else-if="documentAdjustmentAcrStatus === 'UNKNOWN'"
                                icon=" $oss-circle-check "
                                color="primary"
                                @click="goToWindowStep10"
                                size="x-small"
                            />
                            <!-- @click="window_step = 10"
                            @click="dialogDocumentAdjustment = !dialogDocumentAdjustment" -->
                        </template>

                        <!-- ** if no ACR -->
                        <v-btn-icon
                            v-else
                            :disabled="!document.status || document.status !== 'VALIDATED'"
                            icon=" $oss-edit "
                            color="primary"
                            size="x-small"
                            @click="goToWindowStep10"
                        />
                    </template>
                </v-col>
            </v-row>

            <!-- // ++ FIXED-ASSETS -->
            <template
                v-if="
                    showFixedAssets &&
                    fixedAssetsALs &&
                    fixedAssetsALs.length &&
                    isAllowedToFixedAsset
                "
            >
                <v-row no-gutters v-for="fixedAssetsAL in fixedAssetsALs" :key="fixedAssetsAL.id">
                    <v-col cols="auto" class="pr-2 d-flex align-center">
                        <span>
                            Générer amos - {{ fixedAssetsAL.accountableAccount.name }} -
                            {{ newCommonFormatCurrency(fixedAssetsAL.amountSigned) }}
                        </span>
                    </v-col>

                    <!-- <v-col v-if="documentDepreciationsAcrStatus && documentDepreciationsAcrStatus === 'TO_UPDATE'">
                            <span class="error--text">
                                ㅤdocument modifié : les régularisations sont à refaire 2
                            </span>
                        </v-col> -->

                    <v-spacer />

                    <!-- // ++ FIXED-ASSETS -->
                    <v-col cols="auto" class="d-flex justify-end" v-if="isAllowedToFixedAsset">
                        <template v-if="disabledAuditReportLines">
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <div v-bind="props">
                                        <v-btn-icon
                                            icon=" $oss-edit "
                                            :disabled="disabledAuditReportLines"
                                            v-bind="props"
                                            size="x-small"
                                        />
                                    </div>
                                </template>

                                <span
                                    v-if="
                                        tooltipDocumentAdjustmentBtn &&
                                        tooltipDocumentAdjustmentBtn.length
                                    "
                                    >{{ tooltipDocumentAdjustmentBtn }}</span
                                >
                            </v-tooltip>
                        </template>

                        <template v-else>
                            <!-- <v-btn-icon
                                    v-if="documentDepreciationsAcrStatus && documentDepreciationsAcrStatus === 'TO_UPDATE'"
                                    color="error"
                                    size="small"

                                    icon="$oss-warning"
                                    @click="openFixedAssets(fixedAssetsAL.id)"
                                /> -->

                            <v-btn-icon
                                icon=" $oss-circle-check "
                                v-if="
                                    document.status &&
                                    document.status === 'VALIDATED' &&
                                    documentDepreciationsAcrStatus &&
                                    documentDepreciationsAcrStatus === 'UNKNOWN'
                                "
                                color="primary"
                                @click="openFixedAssets(fixedAssetsAL.id)"
                                size="x-small"
                            />

                            <v-btn-icon
                                icon=" $oss-edit "
                                v-else
                                color="primary"
                                @click="openFixedAssets(fixedAssetsAL.id)"
                                size="x-small"
                            />
                        </template>
                    </v-col>
                </v-row>
            </template>
        </v-card>
    </v-container>
</template>

<script lang="ts">
import { State2Way } from "@/decorators";
import moment from "moment-timezone";
import { mathFix } from "../../services/mathServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import {
    adjustmentsPurchasesConditions,
    adjustmentsSalesConditions,
} from "../../services/documentServices";
import { sumBy } from "lodash";
import { User } from "../../store/store";

import { Offer_type } from "@/types/offer.types";

// import { getEmptyDocument } from "../../services/documentServices"
// import AccountableAccountVue from "../AccountableAccount.vue";
// import CheckFixedAssetsToDepreciate from "../audit/CheckFixedAssetsToDepreciate.vue";
import { isInsideClosedAccountingPeriod } from "../../services/accountingPeriods";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { OfferAccessRight } from "@/services/accessRightServices";

@Component({
    components: {
        // AccountableAccountVue,
        // CheckFixedAssetsToDepreciate,
    },
    emits: ["goToWindowStep0", "back"],
})
export class DocumentAuditActions extends Vue {
    @Prop({ default: "" }) companyId: string;
    // @Prop({ default: undefined }) thirdPartyCompany: any;
    @Prop({ default: undefined }) document: any;
    @Prop({ default: undefined }) documentId: any;
    @Prop({ default: 0 }) windowStep: number;
    // @Prop({ default: "" }) documentAcrStatus: string;
    @Prop({ default: undefined }) documentAccountingPeriod: any;

    search: string = "";

    get offerType() {
        return this.$store.state.offerType;
    }

    get isUserHasAccess() {
        return this.$store.getters.isUserHasAccess();
    }

    get isAllowedToFixedAsset() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_BASIC:
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.ACCOUNTING_STARTER:
        // case Offer_type.BUSINESS_BASIC:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.TRAINING:
        // if (this.isUserHasAccess) {
        // return true;
        // }
        // return false;
        // default:
        // return false;
        // }
        return OfferAccessRight.checkOfferAccessRight("isAllowedToFixedAsset", true);
    }

    get window_step() {
        return this.windowStep;
    }

    get selectedAccountingPeriod() {
        return this.$store.state.accountingPeriod.selectedAccountingPeriod;
    }

    @State2Way("updateAccountingPeriods", "accountingPeriod.accountingPeriods")
    accountingPeriods!: any;

    lastClosedAccountingPeriod: any = {};
    previousAccountingPeriod: any = {};

    dialogDocumentAdjustment: boolean = false;
    dialogFixedAssets: boolean = false;

    firstNotClosedDay: any = "";

    tooltipDocumentAdjustmentBtn: String = "";

    aaType: String = "";

    documents: Array<any> = [];

    // acKeyPurchases: string = "FLoYFf9NewVjg7fJyAb6Iucj"
    // acKeySales: string = "eZZcPLQGRZHBLwNM34gpkRpg"

    headerMessage: String = "";

    previousClosedApMessage: String = ""; // only FNP

    removedLinesMessage: String = "";

    completeDates: boolean = false;

    orderedDates: boolean = false;

    differentAdjustments_acrData: boolean = false;

    controlThirdPartyCompany: any = {};

    beforeMount() {
        this.initialize();
    }

    formatDate(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }

    // ++++ The DatePicker needs a format 'YYYY-MM-DD' +++++
    formatDatePicker(date: string) {
        return moment(date).format("YYYY-MM-DD");
    }

    returnToWindowStep0() {
        this.$emit("goToWindowStep0");
        // return true
        // this.windowStep = 0
    }

    goToWindowStep10() {
        this.$emit("goToWindowStep10", {
            auditChildren: "DocumentAdjustments",
            documentACRs: this.documentAdjustmentsACRs,
            documentAcrStatus: this.documentAdjustmentAcrStatus,
            adjustmentAcKey: this.acKey,
            value: 10,
        });
    }

    // goToWindowStep20() {
    openFixedAssets(fixedAssetsALId) {
        const location: any = {
            // name: "fixed-assets-to-depreciate2",
            name: "fixed-assets-to-depreciate",
            params: {
                companyId: this.companyId,
                accountingPeriodId: this.documentAccountingPeriod.id,
                acKey: this.depreciationAcKey,
                accountingLineId: fixedAssetsALId,
                panel: 0,
            },
        };

        this.$router.push(location);
        return;
    }

    get minDate(): any {
        if (this.firstNotClosedDay && this.firstNotClosedDay.length) {
            return moment(this.firstNotClosedDay).format("YYYY-MM-DD");
        } else {
            return undefined;
        }
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    backPath() {
        this.$emit("back");
    }

    initialize() {}

    getDatePickerError(startDate, endDate) {
        if (
            moment(moment(endDate).format("YYYY-MM-DD")).isBefore(
                moment(moment(startDate).format("YYYY-MM-DD")),
            )
        ) {
            return true;
        }
        if (
            !this.firstNotClosedDay ||
            !this.firstNotClosedDay.length ||
            moment(moment(startDate).format("YYYY-MM-DD")).isBefore(
                moment(moment(this.firstNotClosedDay).format("YYYY-MM-DD")),
            )
        ) {
            return true;
        }
        return false;
    }

    get having6or7AccountableAccounts() {
        if (this.document?.accountingLines?.length) {
            const having6or7AA = this.document.accountingLines.find(
                (al) => adjustmentsPurchasesConditions(al) || adjustmentsSalesConditions(al),
            );
            if (having6or7AA) {
                return true;
            }
            return false;
        }
        // ** no accountingLines ?
        return false;
    }

    get showAdjustments() {
        if (this.document?.status === "VALIDATED") {
            if (this.document.isResultOf) {
                return false;
            }
            if (this.having6or7AccountableAccounts) {
                if (
                    ["PURCHASE_INVOICE", "SALES_INVOICE", "MISCELLANEOUS_OPERATION"].includes(
                        this.document.type,
                    )
                ) {
                    return true;
                }
            }
        }
        return false;
    }

    get showFixedAssets() {
        if (
            this.document?.status === "VALIDATED" &&
            this.document.date &&
            !isInsideClosedAccountingPeriod(this.$store, this.document.date)
        ) {
            if (this.document.accountingLines?.length) {
                const havingFixedAssets = this.document.accountingLines.filter(
                    (al) =>
                        al.accountableAccount?.name &&
                        (al.accountableAccount.name.startsWith("20") ||
                            al.accountableAccount.name.startsWith("21") ||
                            al.accountableAccount.name.startsWith("22") ||
                            al.accountableAccount.name.startsWith("23")),
                );

                if (havingFixedAssets?.length) {
                    return true;
                }
            }
        }
        return false;
    }

    get depreciationAcKey() {
        if (this.document) {
            const al2 = this.document.accountingLines.find(
                (al) =>
                    al.accountableAccount?.name &&
                    (al.accountableAccount.name.startsWith("20") ||
                        al.accountableAccount.name.startsWith("21") ||
                        al.accountableAccount.name.startsWith("22") ||
                        al.accountableAccount.name.startsWith("23")),
            );

            if (al2) {
                return "rIr4hG5NdQWyEnIXvhnYtmmm";
            }
        }

        return "";
    }

    get acKey() {
        if (this.document && this.document.type) {
            if (this.document.type === "PURCHASE_INVOICE") {
                return "FLoYFf9NewVjg7fJyAb6Iucj";
            } else if (this.document.type === "SALES_INVOICE") {
                return "eZZcPLQGRZHBLwNM34gpkRpg";
            } else if (this.document.type === "MISCELLANEOUS_OPERATION") {
                const al6 = this.document.accountingLines.filter((al) =>
                    adjustmentsPurchasesConditions(al),
                );

                const al7 = this.document.accountingLines.filter((al) =>
                    adjustmentsSalesConditions(al),
                );

                if (al6 && al6.length && al7 && al7.length) {
                    // ** amounts NOT signed
                    const al6Amount = sumBy(al6, function (al: any) {
                        return al.amount;
                    });
                    const al7Amount = sumBy(al7, function (al: any) {
                        return al.amount;
                    });

                    if (al6Amount && al7Amount && al6Amount > al7Amount) {
                        return "FLoYFf9NewVjg7fJyAb6Iucj";
                    } else {
                        return "eZZcPLQGRZHBLwNM34gpkRpg";
                    }
                } else if (al6 && al6.length) {
                    return "FLoYFf9NewVjg7fJyAb6Iucj";
                } else if (al7 && al7.length) {
                    return "eZZcPLQGRZHBLwNM34gpkRpg";
                } else {
                    return "";
                }
            }
        }
        return "";
    }

    get adjustmentAcKey() {
        if (this.document) {
            if (this.document.type === "PURCHASE_INVOICE") {
                return "FLoYFf9NewVjg7fJyAb6Iucj";
            }

            if (this.document.type === "SALES_INVOICE") {
                return "eZZcPLQGRZHBLwNM34gpkRpg";
            }

            const al6 = this.document.accountingLines.filter((al) =>
                adjustmentsPurchasesConditions(al),
            );

            const al7 = this.document.accountingLines.filter((al) =>
                adjustmentsSalesConditions(al),
            );

            if (al6 && al7) {
                // ** amounts NOT signed
                const al6Amount = sumBy(al6, function (al: any) {
                    return al.amount;
                });
                const al7Amount = sumBy(al7, function (al: any) {
                    return al.amount;
                });

                if (al6Amount && al7Amount && al6Amount > al7Amount) {
                    return "FLoYFf9NewVjg7fJyAb6Iucj";
                } else {
                    return "eZZcPLQGRZHBLwNM34gpkRpg";
                }
            } else if (al6) {
                return "FLoYFf9NewVjg7fJyAb6Iucj";
            } else if (al7) {
                return "eZZcPLQGRZHBLwNM34gpkRpg";
            } else {
                return "";
            }
        }

        return "";
    }

    get documentAdjustmentAcrStatus() {
        if (this.document?.auditCheckResults?.length) {
            let acr;

            if (this.acKey.length) {
                acr = this.document.auditCheckResults.find(
                    (acr) => (acr as any).auditCheck.key === this.acKey,
                );
            }

            if (acr?.id) {
                return acr.status;
            }
        }
        return "";
    }

    get documentDepreciationsAcrStatus() {
        const fixedAssetsAccountingLines = this.document.accountingLines.filter(
            (al) =>
                al.accountableAccount?.name &&
                (al.accountableAccount.name.startsWith("20") ||
                    al.accountableAccount.name.startsWith("21") ||
                    al.accountableAccount.name.startsWith("22") ||
                    al.accountableAccount.name.startsWith("23")),
        );

        const allFixedAssetsWithDepreciation = fixedAssetsAccountingLines.every((al) =>
            al.auditCheckResults?.some((acr) => acr.auditCheck.key === this.depreciationAcKey),
        );
        if (allFixedAssetsWithDepreciation) {
            for (const al of fixedAssetsAccountingLines) {
                const acr = al.auditCheckResults.find(
                    (acr) => acr.auditCheck.key === this.depreciationAcKey,
                );
                if (acr?.id) {
                    if (acr.status === "TO_UPDATE") {
                        return "TO_UPDATE";
                    }
                }
            }
        } else {
            return "";
        }
        return "UNKNOWN";
    }

    get documentAdjustmentsACRs() {
        if (
            this.document &&
            this.document.auditCheckResults &&
            this.document.auditCheckResults.length
        ) {
            let acr;

            if (this.acKey.length) {
                acr = this.document.auditCheckResults.find(
                    (acr) => (acr as any).auditCheck.key === this.acKey,
                );
            }

            if (acr?.id) {
                return acr;
            }
        }
        return "";
    }

    get documentDepreciationsACRs() {
        const fixedAssetsAccountingLines = this.document.accountingLines.filter(
            (al) =>
                al.accountableAccount?.name &&
                (al.accountableAccount.name.startsWith("20") ||
                    al.accountableAccount.name.startsWith("21") ||
                    al.accountableAccount.name.startsWith("22") ||
                    al.accountableAccount.name.startsWith("23")),
        );

        let depreciationACRs = [];
        for (const al of fixedAssetsAccountingLines) {
            const acr = al.auditCheckResults.find(
                (acr) => acr.auditCheck.key === this.depreciationAcKey,
            );
            if (acr?.id) {
                depreciationACRs.push(acr);
            }
        }

        if (depreciationACRs?.length) {
            return depreciationACRs;
        }
        return undefined;
    }

    get disabledAuditReportLines() {
        this.tooltipDocumentAdjustmentBtn = "";

        const aa600000 = this.document.accountingLines.find((al) =>
            al.accountableAccount?.name?.startsWith("600000"),
        );

        if (this.accountingPeriods) {
            if (this.documentAccountingPeriod && this.documentAccountingPeriod.closed) {
                this.tooltipDocumentAdjustmentBtn = "Exercice comptable clôturé ";
                return true;
            }
        } else {
            this.tooltipDocumentAdjustmentBtn = "Exercice comptable à créer ";
            return true;
        }

        if (aa600000) {
            this.tooltipDocumentAdjustmentBtn = "Affecter le c/600000 et valider ";
            return true;
        } else if (this.document.status !== "VALIDATED") {
            this.tooltipDocumentAdjustmentBtn = "Document à valider";
            return true;
        }
        return false;
    }

    get fixedAssetsALs() {
        // debugger
        if (
            this.document &&
            this.document.accountingLines &&
            this.document.accountingLines.length
        ) {
            const fixedAssetsALs = this.document.accountingLines.filter(
                (al) =>
                    al.accountableAccount.name.startsWith("2") &&
                    !al.accountableAccount.name.startsWith("28") &&
                    this.document.isResultOf?.auditCheck?.key !== "rIr4hG5NdQWyEnIXvhnYtmmm",
            );
            if (fixedAssetsALs && fixedAssetsALs.length) {
                return fixedAssetsALs;
            }
            return [];
        }
        return [];
    }
}

export default toNative(DocumentAuditActions);
</script>

<style></style>
